import React, { useState, useEffect } from 'react';
import { Form, Col, Button, Row } from 'react-bootstrap';
import axios from '../Axiosinstance';
import './feedback.css';
import Head from './Headstu';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Rating = () => {
    const [ratings, setRatings] = useState([]);
    const [comments, setComments] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [studentId, setStudentId] = useState('');
    const [batchId, setBatchId] = useState('');
    const { batchid } = useParams();
    const navigate = useNavigate();


    useEffect(() => {
        axios.get('studentfeedbacks')
            .then((response) => {
                const filteredQuestions = response.data.filter((question) => {
                    return question.batchId === null || question.batchId === batchid;
                });
                setQuestions(filteredQuestions);
                setRatings(Array(filteredQuestions.length).fill(0));
                const studentTeacherId = localStorage.getItem('studentteacherid');
                setStudentId(studentTeacherId);
                const batchIdFromAPI = filteredQuestions[0]?.batchId;
                setBatchId(batchIdFromAPI);
            })
            .catch((error) => {
                console.error('Error fetching questions:', error);
            });
    }, [batchid]);


    const validateForm = () => {
        const emptyFields = questions.reduce((acc, question, index) => {
            const answerQ = comments[index] || '';
            const numericRating = ratings[index];
   
            if (question.type !== 2 && (answerQ.trim() === '' || isNaN(numericRating))) {
                acc.push(question.questions);
            }
            return acc;
        }, []);
   
        return emptyFields;
    };


    const handleSubmit = async (event) => {
        event.preventDefault();


        const emptyFields = validateForm();
        
        if (emptyFields.length === questions.length) { // Check if all fields are empty
            toast.error('Please fill in at least one feedback field.');
            return;
        }


        if (emptyFields.length > 0) {
            const errorFields = emptyFields.join(', ');
            toast.error(`Please fill in the following fields: ${errorFields}`);
            return;
        }


        const confirmSubmission = window.confirm('Are you sure you want to submit the feedback?');


        if (confirmSubmission) {
            try {
                const requests = questions.map(async (question, i) => {
                    const answerQ = comments[i] || '' || null;
                    const type = question.type;
                    const numericRating = ratings[i];
                    const feedbackId = question.id;


                    if (answerQ !== '' || !isNaN(numericRating)) {
                        return axios.post('sfreceice', {
                            studentId,
                            batchId: batchId,
                            feedbackId: feedbackId,
                            question: question.questions,
                            type,
                            answerQ: answerQ || null,
                            answerT: !isNaN(numericRating) ? numericRating : null,
                        });
                    }
                    return null;
                });


                const responses = await Promise.all(requests);
                toast.success('Feedback submitted successfully!');
                // console.log('All responses:', responses);


                // toast.success('Feedback submitted successfully!');
                navigate('/Dashboard');
            } catch (error) {
                console.error('Error submitting feedback:', error);
                toast.error('Feedback submission failed. Please try again.');
            }
        }
    };


    const handleCancel = () => {
        window.alert('Feedback submission cancelled.');
        navigate('/Dashboard');
    };


    const handleRatingChange = (selectedRating, index) => {
        const numericRating = Number(selectedRating);
        const updatedRatings = [...ratings];
        updatedRatings[index] = numericRating;
        setRatings(updatedRatings);
    };


    const handleCommentChange = (event, index) => {
        const updatedComments = [...comments];
        updatedComments[index] = event.target.value;
        setComments(updatedComments);
    };


    return (
        <>
            <div className="container mt-5">
            <ToastContainer position="bottom-right" />
                <h2>Feedback Questions</h2><br/>
                <div style={{ maxHeight: '800px', maxWidth: '1000px', overflowY: 'auto' }}>
                    <Form onSubmit={handleSubmit} style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '5px' }}>
                        <Row>
                            {questions.length > 0 &&
                                questions.map((question, index) => (
                                    <Col key={index} xs={12} className="mb-4">
                                        <div>
                                            <p style={{ paddingRight: '80px' }}>
                                                {index + 1}. {question.questions}
                                            </p>
                                            {question.type === 2 ? (
                                                <div className="rating">
                                                    {[1, 2, 3, 4, 5].map((star) => (
                                                        <span
                                                            key={star}
                                                            className={`star ${
                                                                star <= ratings[index] ? 'filled' : ''
                                                            }`}
                                                            onClick={() => handleRatingChange(star, index)}
                                                        >
                                                            &#9733;
                                                        </span>
                                                    ))}
                                                </div>
                                            ) : (
                                                <Form.Group controlId={`comment_${index}`}>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        placeholder="Add a Comment"
                                                        value={comments[index] || ''}
                                                        onChange={(event) => handleCommentChange(event, index)}
                                                    />
                                                </Form.Group>
                                            )}
                                        </div>
                                    </Col>
                                ))}
                        </Row>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                        <Button variant="danger" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </Form>
                </div>
            </div>
        </>
    );
};

function Feedback() {
    return (
      <div>
        <Head/>
        <Rating/>
      </div>
    )
  }


export default Feedback




